    <div class="auth-shell auth-shell-register">
      <aside class="auth-aside">
        <div class="auth-brand">
          <img class="auth-logo" src="/rectangular%20logo.PNG" alt="Central Profile" />
          <span class="eyebrow">Password recovery</span>
          <h1 class="hero-title">Request a secure reset link to regain access quickly.</h1>
        </div>
      </aside>

      <section class="auth-panel">
        <div class="auth-card">
          <h2 class="page-title auth-title-reset">Forgot password</h2>
          <form class="form-stack" [formGroup]="form" (ngSubmit)="submit()">
            <div class="input-group">
              <label for="email">Username or email</label>
              <input id="email" type="email" formControlName="email" placeholder="you@example.com" />
            </div>
            <button class="btn btn-primary" type="submit">Reset password</button>
          </form>
          <div class="auth-links auth-links-spaced">
            <a routerLink="/login" class="label">Return to login</a>
          </div>
        </div>
      </section>
    </div>
